<router-outlet />
<p-toast position="bottom-right" />
<pek-version-info />
